export default "__VITE_ASSET__CR6Egmn___"